import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "animated-input-label-layout" }
const _hoisted_2 = { class: "animated-input-label-layout__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "inputContainerRef",
      class: _normalizeClass([
        'animated-input-label-layout__input',
        _ctx.value && 'animated-input-label-layout__input--has-value',
        (_ctx.isFocused || _ctx.hasPlaceholder) &&
          'animated-input-label-layout__input--focused',
        (_ctx.applyTransformation || _ctx.inputHasPrefix) &&
          'animated-input-label-layout__input--transformed',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1)
    ], 2)
  ]))
}